import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        },

        {
          path: '/development-plan',
          name: 'DevelopmentPlan',
          component: resolve => require(['@/view/DevelopmentPlan.vue'], resolve),
          meta: {
            title: '发展规划'
          }
        },
        {
          path: '/cooperation',
          name: 'cooperation',
          component: resolve => require(['@/view/Cooperation'], resolve),
          meta: {
            title: '合作共赢'
          },
          children: [
            {
              path: '/cooperation',
              redirect: '/cooperation/join-investment'
            },
            {
              path: '/cooperation/join-investment',
              name: 'JoinInvestment',
              component: resolve => require(['@/view/JoinInvestment'], resolve),
              meta: {
                title: '合作共赢 | 招商加盟'
              }
            },
            {
              path: '/cooperation/business-cooperation',
              name: 'BusinessCooperation',
              component: resolve => require(['@/view/BusinessCooperation'], resolve),
              meta: {
                title: '合作共赢 | 商务合作'
              }
            }
          ]
        },
        {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js